import { render, staticRenderFns } from "./bottomCont.vue?vue&type=template&id=621d5cfc&scoped=true"
import script from "./bottomCont.vue?vue&type=script&lang=js"
export * from "./bottomCont.vue?vue&type=script&lang=js"
import style0 from "./bottomCont.vue?vue&type=style&index=0&id=621d5cfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621d5cfc",
  null
  
)

export default component.exports